import { render, staticRenderFns } from "./hugeDeviceOpen.vue?vue&type=template&id=5d14206c&scoped=true"
import script from "./hugeDeviceOpen.vue?vue&type=script&lang=js"
export * from "./hugeDeviceOpen.vue?vue&type=script&lang=js"
import style0 from "./hugeDeviceOpen.vue?vue&type=style&index=0&id=5d14206c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d14206c",
  null
  
)

export default component.exports